import { Mail } from 'lucide-react';
import { useI18n } from '../../contexts/I18nContext';

const supportEmail = 'support@edunasser.com';

export default function PortalHelp() {
  const { language } = useI18n();
  const isArabic = language === 'ar';

  return (
    <div className="portal-page portal-help-page">
      <div className="portal-page-heading">
        <div><h1>{isArabic ? 'المساعدة والدعم' : 'Help & Support'}</h1></div>
      </div>
      <section className="portal-card portal-card-body portal-help-card">
        <span className="portal-help-icon"><Mail size={24} /></span>
        <div>
          <h2>{isArabic ? 'راسلنا عبر البريد الإلكتروني' : 'Email our support team'}</h2>
          <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
        </div>
      </section>
    </div>
  );
}
